import { Link } from 'react-router-dom';
import { ShieldX } from 'lucide-react';

interface AccessDeniedProps {
  title?: string;
  description?: string;
  returnPath?: string;
  returnLabel?: string;
}

/**
 * Full-page access denied component for protected routes.
 * Shows when a user tries to access a page they don't have permission for.
 */
export default function AccessDenied({
  title = 'Access Denied',
  description = 'You need admin access to view this page. Please contact your organization administrator if you believe this is an error.',
  returnPath = '/dashboard',
  returnLabel = 'Go to Dashboard',
}: AccessDeniedProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center px-6">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/30 rounded-full mb-4">
          <ShieldX className="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
          {title}
        </h1>
        <p className="text-gray-600 dark:text-gray-300 max-w-md mx-auto mb-6">
          {description}
        </p>
        <Link
          to={returnPath}
          className="btn btn-primary"
        >
          {returnLabel}
        </Link>
      </div>
    </div>
  );
}
